import {FormControl, MenuItem, Select} from "@mui/material";
import {useRecommendedContext} from "../../../context/recommended/RecommendedContext";
import {COLORS} from "../../../ui/Theme";
import {mutate} from "swr";
import {Box} from "@mui/system";
import {useSearchParams} from "react-router-dom";

const RecommendedSettingDropdown = () => {

    const {
        tableData,
        config,
        updateConfig,
        currentConfig,
        configData,
        setConfigData,
    } = useRecommendedContext();

    const [searchParams] = useSearchParams();

    //UPDATE ISDEFAULT CONFIG
    const updateIsDefaultConfig = async (e) => {
        const newValue = e.target.value;

        const selectedConfig = configData.configList.find((item) => item.name === newValue);

        if (selectedConfig) {
            const updatedConfig = {...selectedConfig, is_default: true};

            setConfigData((prev) => ({
                ...prev,
                defaultConfig: updatedConfig,
            }));

            await updateConfig({config_list: [updatedConfig]});

            await Promise.all([
                mutate(["/stock-market/recommended", searchParams.toString()]),
                mutate("/stock-market/v2/recomm-config"),
            ]);
        }
    };

    return (
        <Box sx={{width: {xs: "100%", md: "220px"}}}>
            <FormControl sx={{width: "100%"}}>
                <Select
                    size="small"
                    sx={{
                        width: {xs: "100%", md: "220px"},
                        height: "46px",
                        backgroundColor: COLORS.SOFTBLUE,
                        color: COLORS.BLUE,
                        "& .MuiSelect-icon": {
                            color: COLORS.BLUE,
                        },
                    }}
                    value={currentConfig?.name}
                    onChange={updateIsDefaultConfig}
                    displayEmpty
                    renderValue={(selected) => {
                        if (config.isValidating || tableData.isValidating) {
                            return "در حال بارگذاری...";
                        }
                        if (!selected) {
                            return "انتخاب تنظیمات";
                        }
                        return selected;
                    }}
                    inputProps={{"aria-label": "انتخاب تنظیمات"}}
                >
                    {config?.data?.config_list?.map((item) => (
                        <MenuItem
                            key={item.id}
                            value={item.name}
                        >
                            {item.name}
                        </MenuItem>
                    ))
                    }
                </Select>
            </FormControl>
        </Box>
    );
};

export default RecommendedSettingDropdown;
